import axios from "axios";
import {initialCancelFunction} from "../../../../util/Helpers"

const cancelToken = axios.CancelToken;
let cancelGetDocumentReq = initialCancelFunction;

export const USERS_URL = "/users/pending-action";

// READ
export function getAllPendingActions() {
  return axios.get(USERS_URL);
}

// UPDATE => PUT: confirm the pending Action on the server
export function confirmPendingAction(pendingActionData) {
  return axios.put(`${USERS_URL}/${pendingActionData.id}`, { ...pendingActionData });
}

// DELETE => delete the pendingAction from the server
export function deletePendingAction(pendingActionId) {
  return axios.delete(`${USERS_URL}/${pendingActionId}`);
}

// READ
export function getDocument(path) {
  cancelGetDocumentReq("Cancel Request");
  return axios.get(`/users/document/${path}`, {
      cancelToken: new cancelToken(function executor(cancel) {
        // An executor function receives a cancel function as a parameter
        cancelGetDocumentReq = cancel;
      })
    }
  );
}